import { Box, Skeleton, Text, useColorModeValue } from "@chakra-ui/react";

type InfoRowProps = {
  title: string;
  text: string;
  isLoading?: boolean;
};

export const InfoRow = ({ title, text, isLoading = false }: InfoRowProps) => {
  const titleColor = useColorModeValue('gray.900', 'white')
  const textColor = useColorModeValue('gray.600', 'gray.50')

  return (
    <Box flexGrow={"1"}>
      <Text fontSize="1.1rem" fontWeight={'bold'} color={titleColor}>{title}</Text>
      <Skeleton minHeight="20px" isLoaded={!isLoading}>
        <Text color={textColor}>{text || ""}</Text>
      </Skeleton>
    </Box>
  );
};

export * from './info-row-editable' 